import React, { useState } from 'react';
import breakPoints from 'helpers/Styles';
import Link from 'next/link';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { fixDecimalPlaces } from 'helpers/smallFixes';
import Slider from 'react-slick';

const EssentialProducts = ({ essentialProducts }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  /* Changed the slide display logic depending on the amount of essentialProducts */
  const showSlides = (maxSlides, essentialProducts) => {
    if (essentialProducts.length > maxSlides) {
      return maxSlides;
    }
    return essentialProducts.length;
  };
  const settings = {
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: showSlides(5, essentialProducts),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 764,
        settings: {
          slidesToShow: showSlides(4, essentialProducts),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 613,
        settings: {
          slidesToShow: showSlides(3, essentialProducts),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 463,
        settings: {
          slidesToShow: showSlides(2, essentialProducts),
          slidesToScroll: 1,
        },
      },
    ],
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: false,
    infinite: false,
    speed: 500,
    nextArrow:
      currentSlide < essentialProducts.length - 3 ? (
        <CustomCarouselArrow
          src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/arrow-right-next.png?v=1713800470"
          alt="arrow-right"
        />
      ) : null,
    prevArrow:
      currentSlide > 0 ? (
        <CustomCarouselArrow
          src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/arrow-left-prev.png?v=1713800296"
          alt="arrow-left"
          rightPosition={'100%'}
          leftPosition={'left: -35px;'}
        />
      ) : null,
    beforeChange: (current, next) => {
      if (next >= essentialProducts.length - 1) {
        return false;
      }
    },
    afterChange: (index) => {
      setCurrentSlide(index);
    },
  };

  return (
    <>
      <div className="essential_products_desktop">
        <Slider {...settings}>
          {essentialProducts.map((item, index) => {
            const productImage = item.product
              ? item.product.images.edges[0].node.originalSrc
              : null;
            const productTitle = item.product ? item.product.title : null;
            const productPrice = item.product
              ? item.product.variants.edges[0].node.price
              : null;
            const productVariant = item.product
              ? item.product.variants.edges[0].node
              : null;
            const productHandle = item.product ? item.product.handle : null;
            const imageAlt =
              item?.product?.images?.edges[0]?.node?.altText !== null
                ? item?.product?.images?.edges[0]?.node?.altText
                : productTitle;
            return (
              <div className="essential_product_wrapper" key={index}>
                {index < essentialProducts.length && (
                  <Link href={`/products/${productHandle}`}>
                    <div className="essential_product_single">
                      <div className="image_container">
                        <img
                          draggable="false"
                          src={productImage}
                          alt={imageAlt}
                          className="product_image"
                        />
                      </div>
                      <h2 className="product_title">{productTitle}</h2>
                      <h1 className="product_price">
                        ${fixDecimalPlaces(productPrice)}
                      </h1>
                    </div>
                  </Link>
                )}
              </div>
            );
          })}
        </Slider>
      </div>

      <style jsx>
        {`
          .essential_products_desktop {
            // width: 510px;
            // padding-left: 35px;
            // padding-right: 35px;
            overflow: hidden;
            width: 100%;
          }
          .essential_product_wrapper {
            width: 150px;
          }
          .essential_product_single {
            width: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
          .image_container {
            background: #141414;
            height: 130px !important;
            width: 130px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .product_image {
            width: 100% !important;
            border-radius: 4%;
          }
          .product_title {
            width: 130px;
            color: #ffffff;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            max-height: 60px;
            margin: 0 20px;
            margin-top: 10px;
            font-size: 13px;
            font-weight: 700;
            line-height: 11.72px;
            text-align: left;
          }
          .product_price {
            width: 130px;
            color: #ffffff;
            font-family: 'Roboto-Medium';
            font-size: 20px;
            letter-spacing: 0;
            font-size: 15px;
            font-weight: 400;
            line-height: 11.72px;
            text-align: left;
          }
          .carousel.carousel-slider .control-arrow {
            opacity: 1 !important;
            background: #242424 !important;
            border-radius: 100%;
            max-height: 32px;
            max-width: 32px !important;
            width: 32px !important;
          }
        `}
      </style>
    </>
  );
};

function CustomCarouselArrow({
  src,
  alt,
  onClick,
  rightPosition,
  leftPosition,
}) {
  return (
    <>
      <button className="button" onClick={onClick}>
        <img draggable="false" src={src} alt={alt} />
      </button>
      <style jsx>{`
        .button {
          opacity: 1;
          position: absolute;
          right: ${rightPosition || 0}px;
          top: 50px;
          ${leftPosition || 'right: -35px;'}
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          line-height: 0;
          z-index: 5;
        }
        @media (max-width: ${breakPoints.medium}) {
          .button {
            display: none;
            width: 0px;
            height: 0px;
          }
        }
      `}</style>
    </>
  );
}

export default EssentialProducts;
